import {useEffect, useState} from 'react';

import {udApi} from '@udemy/ud-api';

export const useCoursesPriceRange = () => {
    const [isCoursesPriceRangeLoading, setIsCoursesPriceRangeLoading] = useState(true);
    const [coursesPriceRange, setCoursesPriceRange] = useState(undefined);
    useEffect(() => {
        const fetchCoursePriceRange = async () => {
            setIsCoursesPriceRangeLoading(true);
            const response = await udApi.get('/pricing/courses-price-range/');
            setCoursesPriceRange(response.data);
            setIsCoursesPriceRangeLoading(false);
        };

        fetchCoursePriceRange();
    }, []);

    return {
        isCoursesPriceRangeLoading,
        coursesPriceRange,
    };
};
